module.exports = __webpack_public_path__ + "static/logo-Wshadow-dark-634195a092519a8a61f6a52f17afc183.png";